import React from 'react';
import { pathOr } from 'rambda';
import Text from './Text';

const packageObject = require('../../package.json');

const flexStyle = {
  color: 'silver',
  display: 'flex'
};

const absStyle = {
  position: 'absolute',
  bottom: 0,
  left: '70px'
};

const getVersion = vParam => {
  const version = pathOr('', `${vParam}`, packageObject);
  const versionParts = version.split('-');
  return versionParts.length > 1 && versionParts[1] === 'master' ? versionParts[0] : version;
};

const Version = ({ versionParam = 'version', position = 'flex' }) => (
  <Text style={position === 'absolute' ? { ...flexStyle, ...absStyle } : flexStyle}>
    {`v ${getVersion(versionParam)}`}
  </Text>
);

export default Version;
